import React from "react"
import { StyledPostContent } from "@bufox/wp-post-content"
import styled from "styled-components"
import PropTypes from "prop-types"
import replaceDynamicBlocks from "@bufox/gatsby-utils/fe/dynamic-blocks/replace"
import {
  contentInjector,
  gamAdUnitByName,
  gamActive,
} from "@bufox/gatsby-utils/fe/google-services/ad-manager/utils"

const injectAdManger = children => {
  const adUnitConfiguration = gamAdUnitByName("Within Post Content")
  return contentInjector(
    adUnitConfiguration ? adUnitConfiguration : null,
    children
  )
}

const processChildren = children => {
  children = replaceDynamicBlocks(children)
  if (gamActive()) {
    children = injectAdManger(children)
  }
  return children
}

const ThemePostContent = ({ children, className }) => {
  return (
    <StyledPostContent className={className} processChildren={processChildren}>
      {children}
    </StyledPostContent>
  )
}

const StyledThemePostContent = styled(ThemePostContent)`
  a {
    border-bottom: 2px solid var(--tertiary);
    padding: 2px 0;
  }

  figure > a {
    border: none;
  }
`

export default StyledThemePostContent

ThemePostContent.propTypes = {
  adUnitName: PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
}

ThemePostContent.defaultProps = {
  adUnitName: "Within Post Content",
}
